export default "__VITE_PUBLIC_ASSET__bbdb2a32__"